import './ClickablePlanCard.scss';
import { useBuyPlanHandler } from '@/hooks/useBuyPlanHandler';
import {
  ProductCheckoutContext,
  ProductClickContext,
} from '@/pages/PlanSelection/components';
import PlanCard from '.';
import { PlanCardProps } from './PlanCard';
import { ACTION_VIA_SOURCE_TYPE, getFromText, useAnalytics } from '@/analytics';
import { Link } from '@/components/Link';

type ClickablePlanCardContainerProps = Pick<
  PlanCardProps,
  | 'fluid'
  | 'activePage'
  | 'buttonLoading'
  | 'expandable'
  | 'activePage'
  | 'planDetails'
> & {
  actionViaSource?: ACTION_VIA_SOURCE_TYPE;
  itemIndex?: number;
  countryName?: string;
};

const className = 'c-ClickablePlanCard';
const ClickablePlanCardContainer = ({
  fluid,
  activePage,
  buttonLoading,
  expandable,
  planDetails,
  actionViaSource,
  itemIndex,
  countryName,
}: ClickablePlanCardContainerProps) => {
  const handleBuyPlan = useBuyPlanHandler();
  const analyticsContext = useAnalytics();

  const context: ProductCheckoutContext | ProductClickContext = {
    itemIndex,
    product: planDetails,
    countryName: countryName || 'n/a',
    actionViaSource,
    baseItemId: 'n/a',
  };

  const handleTrackSelectItem = () => {
    analyticsContext?.trackSelectItem({
      plan: planDetails,
      index: itemIndex,
      countryName,
      itemListName: actionViaSource ? getFromText(actionViaSource) : 'n/a',
      baseItemId: 'n/a',
    });
  };

  return (
    <Link
      to={`/esim${planDetails.path}`}
      state={{
        analyticsData: {
          countryName,
          itemIndex,
          actionViaSource,
        },
      }}
      className={className}
      onClick={handleTrackSelectItem}
    >
      <PlanCard
        planDetails={planDetails}
        fluid={fluid}
        activePage={activePage}
        buttonLoading={buttonLoading}
        expandable={expandable}
        onBuyNowClick={() => handleBuyPlan(context)}
        isCardLinkable
      />
    </Link>
  );
};

export default ClickablePlanCardContainer;
